import React from "react";
import { connect } from "react-redux";
import {
  setCanonFinancePayout,
  setFinanceSubtype,
  setResidualValue,
  setThirdPartyPayout
} from "../redux/actions";
import { formatMoney } from "accounting-js";
import {
  theMsaInstallmentValue,
  theMsaInstalmentFrequency,
  theMsaPayableMethod,
  theMsaTerm,
  totalPayout
} from "../redux/selectors";
import { OnBlurInput } from "./OnBlurInput";
import { Form, Row, Col, InputGroup } from "react-bootstrap";

function FianceMsa({
  setFinanceSubtype,
  financeSubtype,
  canonFinancePayout,
  setCanonFinancePayout,
  thirdPartyPayout,
  setThirdPartyPayout,
  totalPayout,
  theMsaTerm,
  theMsaPayableMethod,
  theMsaInstallmentValue,
  theMsaInstalmentFrequency,
  residualValue,
  setResidualValue
}) {
  return (
    <>
      <Form.Group as={Row} controlId="financeSubtype">
        <Form.Label sm={3} column>
          Finance Subtype
        </Form.Label>
        <Col sm={3}>
          <Form.Control
            as="select"
            onChange={e => setFinanceSubtype(e.target.value)}
            value={financeSubtype}
          >
            <option value="RENTAL">RENTAL</option>
            <option value="LEASE">LEASE</option>
          </Form.Control>
        </Col>
      </Form.Group>

      <Form.Group as={Row} controlId="canonFinancePayout">
        <Form.Label sm={3} column>
          Canon Finance Payout
        </Form.Label>
        <Col sm={3}>
          <InputGroup>
            <InputGroup.Prepend>
              <InputGroup.Text>$</InputGroup.Text>
            </InputGroup.Prepend>
            <Form.Control
              as={OnBlurInput}
              type="number"
              value={canonFinancePayout}
              onConfirm={e => setCanonFinancePayout(e.target.value)}
              min="0"
            />
          </InputGroup>
        </Col>
      </Form.Group>

      <Form.Group as={Row} controlId="thirdPartyPayout">
        <Form.Label sm={3} column>
          Third Party Payout
        </Form.Label>
        <Col sm={3}>
          <InputGroup>
            <InputGroup.Prepend>
              <InputGroup.Text>$</InputGroup.Text>
            </InputGroup.Prepend>
            <Form.Control
              as={OnBlurInput}
              type="number"
              value={thirdPartyPayout}
              onConfirm={e => setThirdPartyPayout(e.target.value)}
              min="0"
            />
          </InputGroup>
        </Col>
      </Form.Group>

      <Form.Group as={Row}>
        <Form.Label sm={3} column>
          Total Payout
        </Form.Label>
        <Col sm={9}>
          <p className="form-control-plaintext">
            Canon Finance Payout + Third Party Payout ={" "}
            {formatMoney(canonFinancePayout)} + {formatMoney(thirdPartyPayout)}{" "}
            = {formatMoney(totalPayout)}
          </p>
          <small className="form-text text-muted">
            The Total Payout is distributed onto each quote item.
          </small>
        </Col>
      </Form.Group>

      <Form.Group as={Row} controlId="residualValue">
        <Form.Label sm={3} column>
          Residual Value
        </Form.Label>
        <Col sm={3}>
          <InputGroup>
            <InputGroup.Prepend>
              <InputGroup.Text>$</InputGroup.Text>
            </InputGroup.Prepend>
            <Form.Control
              as={OnBlurInput}
              type="number"
              value={residualValue}
              onConfirm={e => setResidualValue(e.target.value)}
              min="0"
            />
          </InputGroup>
        </Col>
      </Form.Group>

      <Form.Group as={Row}>
        <Form.Label sm={3} column>
          Finance Term
        </Form.Label>
        <Col sm={9}>
          <p className="form-control-plaintext">{theMsaTerm}</p>
        </Col>
      </Form.Group>

      <Form.Group as={Row}>
        <Form.Label sm={3} column>
          Payable Method
        </Form.Label>
        <Col sm={9}>
          <p className="form-control-plaintext">{theMsaPayableMethod}</p>
        </Col>
      </Form.Group>

      <Form.Group as={Row}>
        <Form.Label sm={3} column>
          Instalment Value
        </Form.Label>
        <Col sm={9}>
          <p className="form-control-plaintext">
            {formatMoney(theMsaInstallmentValue)}
          </p>
        </Col>
      </Form.Group>

      <Form.Group as={Row}>
        <Form.Label sm={3} column>
          Instalment Frequency
        </Form.Label>
        <Col sm={9}>
          <p className="form-control-plaintext">{theMsaInstalmentFrequency}</p>
        </Col>
      </Form.Group>
    </>
  );
}

export default connect(
  state => ({
    state: state,
    financeSubtype: state.quote.finance.financeSubtype,
    canonFinancePayout: state.quote.finance.canonFinancePayout,
    thirdPartyPayout: state.quote.finance.thirdPartyPayout,
    totalPayout: totalPayout(state),
    theMsaPayableMethod: theMsaPayableMethod(state),
    theMsaInstallmentValue: theMsaInstallmentValue(state),
    theMsaInstalmentFrequency: theMsaInstalmentFrequency(state),
    theMsaTerm: theMsaTerm(state),
    residualValue: state.quote.finance.residualValue
  }),
  {
    setFinanceSubtype,
    setCanonFinancePayout,
    setThirdPartyPayout,
    setResidualValue
  }
)(FianceMsa);
